import React from 'react'
import MaintenancePage from '../../Pages/maintainnance/MaintenancePage'

const CollegeReview = () => {
  return (
    <>
    <MaintenancePage />
    </>
  )
}

export default CollegeReview